// FreePage Event
import { FPEvent, TemplateDTO } from "./index";
/**
 * FreePage 中的模块类型
 *
 * @export
 * @enum {number}
 */

export enum FreePageModuleType {
  FreeBlock = "freeBlock",
  NativeCommonProductCard = "native_common_product_card",
}
export interface FPModuleWarp {
  data: FPModule;
  templateDTO: TemplateDTO; // 附加参数

  rendered: boolean;
}
/**
 * FreePage 模块
 *
 * @export
 * @interface FPModule
 */

export interface FPModule {
  data: object; // 数据

  type: FreePageModuleType; // 模块类型

  events: FPEvent[]; // 事件

  modulePerLine: number; // 一行几列 （默认 List 为 1，Gallery 为 2）

  freeBlockTemplateName: string; // DX 模版名 eg. icbu_dx_gallery_list_product_card_10

  layout: string; // layout 布局类型

}
/**
 * Freepage 中 Tab Item 结构
 *
 * @export
 * @interface FPTabItemModule
 * @extends {FPModule}
 */

export interface FPTabItemModule extends FPModule {
  imageUrl?: string; // TabItem 标题前的小 ICON 图标

}
export const appNativeComponentMap = {
  [FreePageModuleType.NativeCommonProductCard]: {
    name: "icbu_dx_gallery_list_product_card_10",
    url: "https://ossgw.alicdn.com/rapid-oss-bucket/1582287038076/gallery_list_product_card.js"
  }
};